import { SimpleCard } from '#/components/ui/SimpleCard';
import { DEFAULT_LEARN_MORE_RESOURCE_CARDS } from '#/content/static';

interface StaticLearnMoreResourcesSectionProps {
  /**
   * Section anchor id. Detail pages pass `learn-more` when the editorial
   * LearnMoreSection above is absent, so the nav's Learn More entry — which is
   * always advertised — still has a target to scroll to.
   */
  id?: string;
}

export function StaticLearnMoreResourcesSection({
  id,
}: StaticLearnMoreResourcesSectionProps = {}) {
  return (
    <section
      id={id}
      className="md:gap-gap grid scroll-mt-(--scroll-offset) grid-cols-1 gap-24 md:grid-cols-3"
    >
      {DEFAULT_LEARN_MORE_RESOURCE_CARDS.map((props) => (
        <SimpleCard
          key={props.title}
          {...props}
          target="_blank"
          rel="noopener noreferrer"
          dataTrack="static_resource_card"
          dataTrackLabel={props.title}
          dataTrackContext="learn_more_resources"
        />
      ))}
    </section>
  );
}
